import useApi from "../../hooks/useApi";
import React, {cloneElement, ReactComponentElement, useCallback, useMemo, useState} from "react";
import {Button, SelectBox} from "devextreme-react/select-box";
import ILookupItem from "../../models/ILookupItem";
import {controllerName} from "../../types"
import PopupPage from "../popups/PopupPage";
import {dxButtonOptions} from "devextreme/ui/button";
import Guid from "../../models/Guid";
// import {useQuery, useQueryClient} from "@tanstack/react-query";
import {useQuery} from "@tanstack/react-query";
import {ButtonOptions} from "devextreme-react/form";

type IUseLookupParameters = {
    controllerName: controllerName,
    setDataRow?: Function,
    onClearRow?: Function,
    cacheKey?: string// = `lookup-${controllerName}`,
    staleTime?: number,
    path?: string// = "lookup",
    valueExp?: string// = 'id',
    displayExpr?: string //= "description",
    parameters?: { name: string, value: string }[],
    showFind?: boolean
    showClear?: boolean
    showDropDown?: boolean,
    isModeModifier?: boolean
    disabled?: boolean,
    width?: string,
    titre?: string,
    includeEmpty?: boolean
}

const defaultUseLookUpParameterValue = {disabled: false, path: "lookup", valueExp: 'id', displayExpr: 'description', parameters: [], showFind: true, showClear: true, showDropDown: true, staleTime: 10 * 60 * 1000, includeEmpty: true}

function getParameterCaseInsensitive(object: any, key: string) {
    const asLowercase = key.toLowerCase();
    return object[Object.keys(object)
        .find(k => k.toLowerCase() === asLowercase) as any
        ];
}

function useLookUpBase<T extends ILookupItem>(props: IUseLookupParameters) {
    const {
        controllerName,
        displayExpr,
        valueExp,
        cacheKey,
        staleTime,
        path,
        parameters,
        setDataRow,
        onClearRow,
        showClear,
        showFind,
        showDropDown,
        isModeModifier,
        disabled,
        width,
        titre,
        includeEmpty
    } = {...defaultUseLookUpParameterValue, ...{cacheKey: `lookup-${props.controllerName}`}, ...props};

    // const queryClient = useQueryClient();
    const stringParameter = parameters?.map(p => `${p.name}=${p.value}`).join('&')
    const {getData: getLookUpBase} = useApi<T[]>(`${controllerName}/${path}${stringParameter && stringParameter !== "" ? `?${stringParameter}` : ""}`);
    const lookupQueryKey = useMemo(
        () => [cacheKey || `lookup-${controllerName}`, controllerName, path, stringParameter || ''] as const,
        [cacheKey, controllerName, path, stringParameter]
    );
    const {data: lookUpBaseData, refetch, dataUpdatedAt} = useQuery({
        // queryKey: [cacheKey || `lookup-${props.controllerName}`, props.controllerName, getLookUpBase, cacheKey],
        queryKey: lookupQueryKey,
        queryFn: () => getLookUpBase(),
        staleTime: staleTime,
    })
    const lookupRows = useMemo(
        () => (Array.isArray(lookUpBaseData) ? lookUpBaseData : []),
        [lookUpBaseData]
    );
    const {getData: getCurrent} = useApi<any>(`${controllerName}`);
    const [currentSelectedItem, setCurrentSelectedItem] = useState<T>();
    const [isPopupGestionOpen, setIsPopupGestionOpen] = useState(false);
    const removeById = (id: string) => {
    }

    interface IPopupGestionClientProps {
        onSelectionchanged?: (item: T) => void,
        children: ReactComponentElement<any>
    }


    const PopupGestion = ({onSelectionchanged, children}: IPopupGestionClientProps) => {
        const childs = useMemo(() => {
            if (React.isValidElement(children)) {
                return cloneElement(children, {
                    ...children.props,
                    isModeSelection: true
                })
            }
            return children;
        }, [children])

        if (isPopupGestionOpen)
            return (
                <PopupPage<Guid> titre={titre || `Sélection d'un ${controllerName}`} isPopupOpen={isPopupGestionOpen} onClose={() => setIsPopupGestionOpen(false)} width={"95vw"} height={"95vh"} mode={"liste"}
                                 isModeModifier={isModeModifier}
                                 onSelection={async (id) => {
                                     // const refetchedData = await refetch();
                                     // const selected = refetchedData.data?.find(f => f.id == id);
                                     // setCurrentSelectedItem(selected);
                                     // if (selected && onSelectionchanged) {
                                     //   onSelectionchanged(selected);
                                     //   refetch()
                                     // }

                                     // if (modelBaseId && (id as any)?.[modelBaseId]) {
                                     // setCurrentSelectedItem(selectedItem as unknown as T)
                                     // Extract the correct ID for the form field and update parent
                                     // const itemId = (id as any)[modelBaseId];
                                     if (id && onSelectionchanged) {
                                         onSelectionchanged(id as unknown as T);
                                         refetch();
                                         // }
                                         // if (setDataRow) {
                                         //   setDataRow(itemId);
                                         // }
                                     }

                                     setIsPopupGestionOpen(false);
                                 }}>
                    {childs}
                </PopupPage>
            )
        return null;
    }

    // useEffect(() => {
    //     refetch();

    // }, [path, controllerName])

    const editorOptions = useMemo(() => {
        const rows = includeEmpty
            ? lookupRows
            : lookupRows.filter(f => !f.id.equals(Guid.empty))
        return {
            width: width,
            disabled: disabled,
            searchEnabled: true,
            showDropDownButton: showDropDown,
            dataSource: rows.slice(),
            displayExpr: displayExpr,
            valueExpr: valueExp,
            buttons: [{
                name: "find", options: {
                    onClick: () => setIsPopupGestionOpen(true), stylingMode: "text", disabled: disabled,
                    icon: "find",
                    visible: showFind
                }
            },
                {
                    name: "remove", options: {
                        onClick: () => onClearRow && onClearRow(),
                        stylingMode: "text", disabled: disabled,
                        icon: "remove",
                        visible: showClear
                    },
                },
                {
                    name: "dropDown"
                }],
            onValueChanged: (e: any) => {
                getCurrent({customPath: `${controllerName}/${e.value}`}).then((data) => {
                    setCurrentSelectedItem(data as unknown as T)
                });
            },
        }
    }, [disabled, lookupRows, includeEmpty, controllerName, displayExpr, valueExp, getCurrent, setDataRow, showFind, showClear, showDropDown, width, dataUpdatedAt])

    const lookUpBaseSelectBox = useCallback((params: any) => {
        const {dataField, component, column, data, readOnly, idParent} = params;
        const formOptions = component?.option();
        const value = (dataField ? formOptions.formData[dataField] : data[column.dataField]) || Guid.empty;

        const onValueChanged = (args: any) => {
            // component.updateData(dataField, args.value);
        }
        const filteredDataSource = editorOptions.dataSource?.filter(f => {
            return (f as T).idParent?.equals(idParent);
        })
        const onSelectionChanged = (e: any) => {
            setCurrentSelectedItem(e.selectedItem);
        }

        const findOnClick = useCallback(() => setIsPopupGestionOpen(true), []);
        const clearOnClick = useCallback(() => setDataRow, [setDataRow]);
        return (
            <SelectBox disabled={disabled} openOnFieldClick={true} stylingMode={undefined} readOnly={readOnly || formOptions.readOnly} onSelectionChanged={onSelectionChanged} dataSource={idParent ? filteredDataSource : editorOptions.dataSource} displayExpr={editorOptions.displayExpr} showDropDownButton={showDropDown} valueExpr={editorOptions.valueExpr} value={value} onValueChanged={onValueChanged}>
                <Button name={"find"}>
                    <ButtonOptions stylingMode={"text"} onClick={findOnClick} visible={showFind} disabled={disabled} icon={"find"}/>
                </Button>
                <Button name={"close"}>
                    <ButtonOptions stylingMode={"text"} onClick={clearOnClick} visible={showClear} disabled={disabled} icon={"remove"}/>
                </Button>
                <Button name={"dropDown"} options={{visible: showDropDown}}/>
            </SelectBox>
        )
    }, [editorOptions.dataSource, editorOptions.displayExpr, editorOptions.valueExpr, setDataRow, showFind, showClear, showDropDown, disabled]);

    return {
        editorOptions,
        data: lookupRows,
        currentSelectedItem: currentSelectedItem,
        refreshData: () => getLookUpBase(),
        selectBox: lookUpBaseSelectBox,
        PopupGestion,
        removeById: (id: string) => removeById(id)
    }
}

export default useLookUpBase;